import { render, staticRenderFns } from "./videoModal.vue?vue&type=template&id=7811d53a&scoped=true"
import script from "./videoModal.vue?vue&type=script&lang=js"
export * from "./videoModal.vue?vue&type=script&lang=js"
import style0 from "./videoModal.vue?vue&type=style&index=0&id=7811d53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7811d53a",
  null
  
)

export default component.exports